<template>
    <div class="workersGroupDetails">
        <mediaCenter tabIndex="1"></mediaCenter>
        <div class="contentBox">
           <div :class="isMobile?'contentM':'content'">
                <p class="title">{{info.title}}</p>
                <div class="contents" v-html="info.content"></div>
           </div>
        </div>
    </div>
</template>

<script>
     import mediaCenter from '@/components/mediaCenter'
	export default {
		name:'mediaCenterd',
        components: {
            mediaCenter
        },
        data() {
            return {
                info:''
            }
        },
        mounted(){
           this.getInfo()
        },
       methods:{
         //获取行业资讯详情
         getInfo(){
            this.Request({
                url: '/prod-api/hzfglSys/news/public/detail/' + this.$route.query.id,
                method: 'get',
            }).then((res) => {
                this.info = res.data
            })
        }
       }
	}
</script>

<style scoped lang="less">
    .contentBox{
        background-color: #F7F8F9;
        padding: 42px 0;
    }
    .content{
        width: 1200px;
        margin: 0 auto;
        background-color: #fff;
        padding: 44px;
        border-radius: 3px;
    }
    .contentM{
        width: 100%;
        padding: 20px;
        background-color: #fff;
    }
    .title{
        margin-top: 13px;
        text-align: center;
        font-size: 21px;
        font-weight: bold;
    }
    .contents{
        margin-top: 64px;
        font-size: 15px;
        line-height: 1.8;
        color: #303133;
        word-break: break-word;
    }

   
</style>
<style>
     .workersGroupDetails .contents p{
        margin: 0 0 1em;
     }
     .workersGroupDetails .contents img{
        max-width: 100% !important;
        height: auto !important;
        border-radius: 4px;
     }
     .workersGroupDetails .contents table{
        width: 100%;
        border-collapse: collapse;
     }
     .workersGroupDetails .contents td,
     .workersGroupDetails .contents th{
        border: 1px solid #ddd;
        padding: 8px 12px;
     }
</style>